import { actions as archivedJobActions } from '@saucelabs/sl-module-archived-jobs';
import { actions as userActions } from '@saucelabs/sl-module-user';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as queryOperations from './../query/operations';
import * as queryActions from './../query/actions';
import * as columnsActions from './../columns/actions';


const setupXTMFilters = ({ user, jobsTeamSharingEnabled }) => async (dispatch) => {
  if (jobsTeamSharingEnabled) {
    await dispatch(queryActions.getTeamList());
  } else {
    // if team sharing is off
    // we want to only show user's teams on the list
    dispatch(queryActions.extendFacet({ name: 'teams', items: user.get('teams').map((team) => team.id) }));
    // and we want to show only logged in user on the owners list
    dispatch(queryActions.extendFacet({ name: 'owner', items: [user.get('username')] }));
  }
};

export const initialize = ({ user, jobsTeamSharingEnabled }) => async (dispatch) => {
  await dispatch(setupXTMFilters({ user, jobsTeamSharingEnabled }));
  // before we will call 'query from URL', we have to fetch all async filters first
  await dispatch(queryOperations.getQueryFromURL());
  // bootstrap the view
  return Promise.all([
    dispatch(queryOperations.buildFullQuery()),
    dispatch(columnsActions.getColumns()),
    dispatch(userActions.getSiblings({ username: user.get('username') })),
    dispatch(archivedJobActions.getSavedQueries()),
  ])
    .then(([query]) => {
      dispatch(actions.initialized());
      // finally, query for jobs
      return dispatch(queryOperations.search({ payload: query }));
    });
};

export const saveQuery = (query) => (dispatch) => {
  if (!query) {
    return dispatch(notificationActions.notifyDanger('You can\'t save an empty query.'));
  }

  return dispatch(archivedJobActions.saveQuery(query))
    .then(() => dispatch(notificationActions.notifySuccess('Your query has been saved!')))
    .catch((err) => {
      if (err?.response?.data) {
        const { detail, message } = err.response.data;
        return dispatch(notificationActions.notifyDanger(detail, message));
      }

      return dispatch(notificationActions.notifyDanger('We couldn\'t save your query.'));
    });
};

export const deleteSavedQuery = (id) => (dispatch) => (
  dispatch(archivedJobActions.deleteQuery(id))
    .then(() => {
      dispatch(notificationActions.notifySuccess('You deleted query!'));
      return dispatch(archivedJobActions.getSavedQueries());
    })
    .catch((err) => {
      if (err?.response?.data) {
        const { detail, message } = err.response.data;
        return dispatch(notificationActions.notifyDanger(detail, message));
      }

      return dispatch(notificationActions.notifyDanger('We couldn\'t delete selected query.'));
    })
);

export const toggleJobSelection = (payload) => (dispatch) => {
  dispatch(actions.toggleJobSelection(payload));
};

export const setJobSelection = (payload) => (dispatch) => {
  dispatch(actions.setJobSelection(payload));
};

export const clearJobSelection = (payload) => (dispatch) => {
  dispatch(actions.clearJobSelection(payload));
};

export const removeJobs = (payload) => async (dispatch) => {
  /* eslint camelcase: 0 */
  await dispatch(queryActions.resetPage());
  await dispatch(archivedJobActions.remove({ data: { job_ids: payload } }));
  dispatch(actions.clearJobSelection(payload));
  const query = await dispatch(queryOperations.buildFullQuery());
  return dispatch(queryOperations.search({ payload: query }));
};
